import { useEffect, useState } from "react";

/**
 * Create a debounced value that updates after the interval expires
 *
 * @param   {string}    value:        The value of the debounced variable
 * @param   {number}    delay:        The delay in ms
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
